@if (isLoading) {
    <div class="loading-container">
        <app-loading [size]="'60px'"></app-loading>
    </div>
} @else {
    <div class="library-layout" @fadeIn>
        <!-- Left Sidebar: Category Tree -->
        @if (libraryType === 'categories' && categoryTreeItems.length > 0) {
            <div class="sidebar">
                <div class="sidebar-tree">
                    <app-category-tree
                        [createMode]="false"
                        [filterMode]="true"
                        [expandAll]="true"
                        [setCategoryValues]="categoryTreeItems"
                        (updateTreeSelection)="onUpdateTree($event)">
                    </app-category-tree>
                </div>
            </div>
        }

        <!-- Right Content: Resource Carousels -->
        <div class="resources-library-container">
            @if (resourceGroups.length === 0) {
                <div class="no-resources">
                    <mat-icon>folder_open</mat-icon>
                    <p>{{ 'general.noResourcesAvailable' | transloco }}</p>
                </div>
            } @else {
                @for (group of resourceGroups; track group.groupName) {
                    <div class="resource-group" @groupFade [attr.data-group]="group.groupName">
                        <div class="group-header">
                            <mat-icon>{{ libraryType === 'categories' ? 'folder' : 'business' }}</mat-icon>
                            <h3>{{ group.groupName }}</h3>
                            <span class="resource-count">({{ group.resources.length }})</span>
                        </div>

                        <div class="carousel-container" @cardStagger>
                            <ngx-flicking
                                class="flicking"
                                [options]="flickConfig"
                                [plugins]="group.plugins">
                                @for (resource of group.resources; track resource) {
                                    <div flicking-panel class="panel" (click)="openImportDialog(resource)">
                                        <div class="resource-card">
                                            <div class="resource-thumbnail">
                                                @if (resource.resourceType === 'mp4') {
                                                    <div class="resource-placeholder video-placeholder">
                                                        <mat-icon>play_circle_filled</mat-icon>
                                                    </div>
                                                } @else if (resource.resourceType === 'svg' || resource.resourceType === 'png' || resource.resourceType === 'jpg' || resource.resourceType === 'jpeg' || resource.resourceType === 'gif') {
                                                    <img [src]="resource.url"
                                                         [alt]="resource.name"
                                                         loading="lazy"
                                                         decoding="async"
                                                         draggable="false"
                                                         class="resource-image">
                                                } @else {
                                                    <div class="resource-placeholder">
                                                        <mat-icon>insert_drive_file</mat-icon>
                                                    </div>
                                                }
                                            </div>
                                            <span class="resource-name" [title]="resource.name">{{ resource.name }}</span>
                                        </div>
                                    </div>
                                }
                                <span in-viewport class="flicking-arrow-prev">
                                    <mat-icon>chevron_left</mat-icon>
                                </span>
                                <span in-viewport class="flicking-arrow-next">
                                    <mat-icon>chevron_right</mat-icon>
                                </span>
                            </ngx-flicking>
                        </div>
                    </div>
                }
            }
        </div>
    </div>
}

<ng-template let-modal #importModal>
    <div class="section-header" mat-dialog-title>
        <mat-icon class="section-icon">downloading</mat-icon>
        <span class="section-title">{{ 'general.importNewResource' | transloco }}</span>
        <button mat-icon-button class="close-button" (click)="onClose()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div mat-dialog-content>
        <div class="import-dialog-content">
            <div class="resource-details">
                <div class="resource-meta-inline">
                    <span><strong>{{ 'general.name' | transloco }}:</strong> {{ selectedResource.name }}</span>
                    <span class="separator">|</span>
                    <span><strong>{{ 'general.category' | transloco }}:</strong> {{ selectedResource.treePath }}</span>
                    <span class="separator">|</span>
                    <span><strong>{{ 'general.format' | transloco }}:</strong> {{ selectedResource.resourceType }}</span>
                </div>
            </div>

            <div class="resource-preview">
                @if (selectedResource.resourceType === 'mp4') {
                    <video controls [src]="selectedResource.videoUrl" class="preview-video"></video>
                } @else {
                    @if (imageLoading) {
                        <div class="loading-preview">
                            <app-loading [size]="'60px'"></app-loading>
                        </div>
                    }
                    <img [hidden]="imageLoading" (load)="onImageLoad()" [src]="selectedResource.url" class="preview-image" />
                }
            </div>

            <div class="dialog-actions">
                <button mat-raised-button color="warn" (click)="onImportClick()">
                    <mat-icon>downloading</mat-icon>
                    {{ 'general.import' | transloco }}
                </button>
                <button mat-raised-button color="primary" (click)="onClose()">
                    {{ 'general.cancel' | transloco }}
                </button>
            </div>
        </div>
    </div>
</ng-template>
